import {createSlice} from '@reduxjs/toolkit';
//types
import {} from '../../utils/types';
//actions
import {getReportedColumns, getReportFullData, getReportMaxBids, getReportParticipants, getReportUnpaidItems, getReportUnpaidTables} from './actions';
//operations
import {
	getFinancialReportOperation,
	getMaxBidsOperation,
	getParticipantsOperation,
	getReportedColumnsOperation,
	getUnpaidItemsOperation,
	getUnpaidTablesOperation,
	pendingOperation,
	rejectedOperation,
} from './operations';
//constants
import {initialOrganizationData, initialReportData} from '@/utils/constants';
import {IOrganizationReportReducer} from '@/utils/types/organization-reports.interface';

export const initialState: IOrganizationReportReducer = {
	unpaidItems: initialOrganizationData,
	unpaidTables: initialOrganizationData,
	participants: initialOrganizationData,
	maxBids: initialOrganizationData,
	isLoading: false,
	columns: [],
	fullReport: initialReportData,


};

const organizationReportStore = createSlice({
	name: 'organizationReport',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getReportUnpaidItems.pending, pendingOperation);
		builder.addCase(getReportUnpaidItems.fulfilled, getUnpaidItemsOperation);
		builder.addCase(getReportUnpaidItems.rejected, rejectedOperation);

		builder.addCase(getReportUnpaidTables.pending, pendingOperation);
		builder.addCase(getReportUnpaidTables.fulfilled, getUnpaidTablesOperation);
		builder.addCase(getReportUnpaidTables.rejected, rejectedOperation);

		builder.addCase(getReportParticipants.pending, pendingOperation);
		builder.addCase(getReportParticipants.fulfilled, getParticipantsOperation);
		builder.addCase(getReportParticipants.rejected, rejectedOperation);

		builder.addCase(getReportMaxBids.pending, pendingOperation);
		builder.addCase(getReportMaxBids.fulfilled, getMaxBidsOperation);
		builder.addCase(getReportMaxBids.rejected, rejectedOperation);

		builder.addCase(getReportedColumns.pending, pendingOperation);
		builder.addCase(getReportedColumns.fulfilled, getReportedColumnsOperation);
		builder.addCase(getReportedColumns.rejected, rejectedOperation);

		builder.addCase(getReportFullData.pending, pendingOperation);
		builder.addCase(getReportFullData.fulfilled, getFinancialReportOperation);
		builder.addCase(getReportFullData.rejected, rejectedOperation);
	},
});

export default organizationReportStore.reducer;
